import instance from 'api/axiosConfig';
import { PretestSingular } from 'api/pretestApi';
import { TestForm } from 'components/shared/TestForm';
import { useState, FC, useEffect } from 'react';
import {
  selectExaminationID,
  selectExaminationIDError,
} from 'redux/examination/selectors';
import { selectExternalUrlsError } from 'redux/externalurls/selectors';
import {
  selectPretestQuestions,
  selectPretestError,
  selectPretestIsReady,
} from 'redux/pretest/selectors';
import { useAppSelector } from 'redux/store';
import { answers } from 'utils/answers';
import { pretestSingleAnswerURL, pretestAllAnswersURL } from 'utils/paths';
import { ErrorPageView } from '../Error';
import { LoadingView } from 'components/shared/Loader';
import { REQUEST_DELAY_TIME_MS } from 'utils/validation';

interface PretestTestProps {
  returnData: (pretestAnswers: PretestSingular[]) => void;
}
const pretestAnswers: PretestSingular[] = [];

export const PretestTest: FC<PretestTestProps> = ({ returnData }) => {
  const examinationId = useAppSelector(selectExaminationID);
  const pretestQuestionsData = useAppSelector(selectPretestQuestions);

  const examinationIDError = useAppSelector(selectExaminationIDError);
  const externalUrlsError = useAppSelector(selectExternalUrlsError);
  const pretestError = useAppSelector(selectPretestError);

  const pretestIsReady = useAppSelector(selectPretestIsReady);

  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (!pretestIsReady) return;

    setTimeout(() => {
      setIsLoading(false);
    }, REQUEST_DELAY_TIME_MS * 2);
  }, [pretestIsReady]);

  const testLength = pretestQuestionsData.length;
  const [position, setPosition] = useState(0);

  const questionsRoute = (selected: string) => {
    const answerData: PretestSingular = {
      question: pretestQuestionsData[position].id,
      answer: selected,
    };
    pretestAnswers.push(answerData);
    void instance.post(pretestSingleAnswerURL(examinationId), answerData);
    if (position < testLength - 1) {
      setPosition(position + 1);
    } else {
      void instance.post(pretestAllAnswersURL(examinationId), pretestAnswers);
      returnData(pretestAnswers);
    }
  };

  if (examinationIDError.error || externalUrlsError.error || pretestError.error)
    return (
      <ErrorPageView
        errorCode={
          examinationIDError.details ||
          externalUrlsError.details ||
          pretestError.details
        }
      />
    );

  if (isLoading) return <LoadingView />;

  return (
    <TestForm
      id={pretestQuestionsData[position].id}
      position={position + 1}
      testLength={testLength}
      question={pretestQuestionsData[position].question}
      answers={answers}
      questionsRoute={questionsRoute}
    />
  );
};
